import { useEffect, useState } from 'react';

import { WINDOW_SELECTOR } from './pwa';

/**
 * Whether a window is up anywhere on the page (the login, the welcome tour, a confirmation…): they don't share a
 * state, so this looks at the page. Watches only while `active`, so visitors with nothing waiting pay nothing.
 */
export const useDialogOpen = (active, selector = WINDOW_SELECTOR) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!active) {
      setIsOpen(false);
      return undefined;
    }
    const check = () => setIsOpen(document.querySelector(selector) !== null);
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [active, selector]);

  return isOpen;
};
